export * from '#/types/elements';
// export * from '#/components/KYCForm/enums';

export enum Themes {
  Light = 'light',
  Dark = 'dark',
  LocalStorageThemeItem = 'theme',
}

export enum Status {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  None = 'NONE',
  Verify = 'VERIFY',
  Verified = 'VERIFIED',
  Agreement = 'AGREEMENT',
  New = 'NEW',
}

export enum RequestStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  None = 'NONE',
}

export enum ToastThemes {
  Light = 'light',
  Dark = 'dark',
  Colored = 'colored',
}
